// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { features, getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { blurHandler, changeHandler, focusHandler } from './handlers';

const IdentityDocumentType = props => {
  useMountLogging('IdentityDocumentType');
  const identityDocumentType = useStoreState(
    ({ form }) => form.identityDocumentType,
  );
  const identityDocumentTypeOptions = features.config.kycIdTypes.map(type => {
    return {
      text: getContent(`fieldValues.${type}`),
      value: type,
    };
  });

  return (
    <FloatingLabelSelect
      blurHandler={blurHandler}
      changeHandler={changeHandler}
      focusHandler={focusHandler}
      id="identityDocumentType"
      label={getContent('fieldLabels.identityDocumentType')}
      required={true}
      selectOptions={identityDocumentTypeOptions}
      {...identityDocumentType}
    />
  );
};

IdentityDocumentType.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { IdentityDocumentType };
